module.exports = __webpack_public_path__ + "media/stylesheets/images/mypage/right-arrow@3x-6ab5e29178562b9d735ce8eadcc93f40.png";